export const FAQ_LINK =
  "https://docs.google.com/document/d/1PaK7Idd-3oY2cn9smu_EZs7l0EJjCOT4R5baerDUjDk/export?format=pdf";

export const CREDIT_CARD_FEE_THRESHOLD = 5000;
